import React, { useMemo } from 'react';
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid } from 'recharts';
import './TestAnalytics.css';

const AccuracyChart = ({ results }) => {
  const data = useMemo(() => {
    if (!results || results.length === 0) return [];
    // Take top 10 for readability, or sort by name
    return results.slice(0, 10).map(r => ({
      name: r.student_name ? r.student_name.split(' ')[0] : 'Unknown', // First name for brevity
      accuracy: r.accuracy
    }));
  }, [results]);

  if (data.length === 0) {
    return (
      <div className="ta-chart-container" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '200px' }}>
        <p style={{ color: '#64748b' }}>Not enough data for Accuracy chart.</p>
      </div>
    );
  }

  return (
    <div className="ta-chart-container">
      <h4 className="ta-chart-title">Top 10 Students Accuracy</h4>
      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={data} margin={{ top: 20, right: 20, left: -20, bottom: 5 }}>
          <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#f1f5f9" />
          <XAxis dataKey="name" tick={{ fontSize: 11 }} axisLine={false} tickLine={false} />
          <YAxis tick={{ fontSize: 11 }} axisLine={false} tickLine={false} domain={[0, 100]} />
          <Tooltip cursor={{ fill: '#fbfaff' }} contentStyle={{ borderRadius: '8px', border: 'none', boxShadow: '0 4px 6px -1px rgba(0,0,0,0.1)' }} />
          <Bar dataKey="accuracy" fill="#4f46e5" radius={[4, 4, 0, 0]} />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default AccuracyChart;
